import { themed } from "@tamagui/helpers-icon";
import { ComponentProps } from "react";
import Svg, { Path } from "react-native-svg";

type SvgBaseProps = ComponentProps<typeof Svg>;

type Props = {
  color?: string;
  size?: number;
} & Omit<SvgBaseProps, "width" | "height" | "color">;
const SyncIcon = themed((props) => {
  const { color = "currentColor", size = 24, ...svgProps } = props as Props;
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...svgProps}
    >
      <Path
        d="M1 9.84722L3.75058 12.4644C3.82789 12.5379 3.92679 12.578 4.02769 12.5829M7.45263 10.4101L4.28804 12.5113C4.20888 12.5638 4.11749 12.5873 4.02769 12.5829M4.02769 12.5829C4.02769 12.5829 4.01785 12.003 4.02769 11.7295C4.18166 7.45198 7.8809 4.10544 12.2902 4.25481C15.1054 4.35019 17.5294 5.84764 18.874 8.03125M23 14.1527L20.2495 11.5356C20.1721 11.462 20.0732 11.4219 19.9723 11.417M16.5474 13.5898L19.712 11.4887C19.7912 11.4361 19.8825 11.4126 19.9723 11.417M19.9723 11.417C19.9723 11.417 19.9822 11.997 19.9723 12.2704C19.8184 16.548 16.1191 19.8945 11.7099 19.7451C8.89463 19.6498 6.47061 18.1523 5.12598 15.9687"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
});

export default SyncIcon;
